import { mdiAccountCircleOutline, mdiChevronDown } from '@mdi/js'
import { Layout, Dropdown, Menu } from 'antd'
import { PagesEnum } from '../../utils/Enums'
import { mdiMenu } from '@mdi/js'
import Icon from '@mdi/react'
import { useAuth } from '../../hooks/auth'
import TabsPanel from '../utility/TabsPanel'
import BridgelinxIcon from '../../logo.png'

const Header = (props) => {
	const { collapseMenu, setCollapseMenu, collection, user } = props.props
	const { logout } = useAuth()

	const DropdownMenu = (
		<Menu className='BoldFont m-0 p-0 !rounded-lg !overflow-hidden !text-center'>
			<Menu.Item key='1'>Profile Info</Menu.Item>
			<Menu.Item key='2' danger onClick={logout}>
				Sign Out
			</Menu.Item>
		</Menu>
	)

	return (
		<>
			<Layout.Header className='flex items-center justify-between !border-solid !border-b-black-75 !h-[72px]'>
				<div className='flex flex-row items-center'>
					<div
						onClick={() => setCollapseMenu(!collapseMenu)}
						className='cursor-pointer flex flex-row items-center h-full w-[11.25rem] py-3 border-r border-black-75 mr-4'
					>
						<div className='mr-4'>
							<Icon className='cursor-pointer text-primary-800' path={mdiMenu} size={1} />
						</div>
						<div className='flex flex-col mr-4 items-start justify-center'>
							<img className=' h-full w-28' src={BridgelinxIcon} alt='' />
							<div className='text-secondary-400 text-[10px] font-medium'>BILTY OPS</div>
						</div>
					</div>
					<div className='ml-2 font-semibold text-base'>{PagesEnum[collection]?.text}</div>
				</div>
				<Dropdown overlay={DropdownMenu} trigger={['click']} className='cursor-pointer'>
					<div title='Profile' className='flex w-max items-center rounded-full bg-primary-50 px-3 py-0 !h-[40px]'>
						<Icon path={mdiAccountCircleOutline} size={1} className='text-primary-800' />
						<p className='px-3 font-[600] text-black-400 text-sm'>{user?.profileInfo?.firstName + ' ' + user?.profileInfo?.lastName}</p>
						<Icon path={mdiChevronDown} size={1} className='text-primary-800' />
					</div>
				</Dropdown>
			</Layout.Header>
			{PagesEnum[collection]?.tabsEnum && <TabsPanel collection={collection} />}
		</>
	)
}

export default Header
